module.exports = __webpack_public_path__ + "img/ico_complete.47935d57.svg";